<template>
  <div style="width: 100%">
    <div class="input-field">
      <v-layout row align-center justify-space-between>
        <label>{{ $tc("Cable", 2) }} </label>
        <v-btn
          small
          text
          icon
          class="px-0 ma-0"
          :disabled="disabled"
          @click="add"
        >
          <v-icon class="accent--text" style="font-size: 14px">
            add_box
          </v-icon>
        </v-btn>
      </v-layout>
    </div>

    <v-slide-y-transition group>
      <template v-for="(cable, index) in cables">
        <v-layout column :key="index">
          <v-divider style="margin: 0 20px" />
          <v-flex xs12>
            <v-radio-group
              v-model="cable.mdec_reserved"
              :column="false"
              :hide-details="true"
              :disabled="disabled"
              class="input-field"
            >
              <v-radio
                label="Existing"
                :value="false"
                :ripple="false"
                color="accent"
              />
              <v-radio
                label="Reservation"
                :value="true"
                :ripple="false"
                color="accent"
              />
            </v-radio-group>
          </v-flex>

          <v-flex xs12 style="padding: 0 20px">
            <v-layout row align-center justify-space-between>
              <v-flex xs6>
                <input
                  v-model="cable.mdec_description"
                  :placeholder="$t('Description')"
                  type="text"
                  :disabled="disabled"
                  class="form-input"
                  style="width: 100%; min-width: 0"
                />
              </v-flex>

              <v-flex xs5>
                <duct-entry-form-cable-selection-treeselect
                  :placeholder="'Type'"
                  :cable="cable"
                />
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 style="padding: 0 20px 4px 20px">
            <v-layout row align-center>
              <v-flex xs10>
                <duct-entry-form-cable-selection-treeselect
                  :placeholder="'Operator'"
                  :cable="cable"
                />
                <!--                <treeselect
              v-if="cable.state == 1"
              v-model="cable.cable"
              class="form-input-select"
              :options="cableOptions"
              :placeholder="$tc('Cable', 1)"
              :disabled="disabled"
              disableFuzzyMatching
            />-->
              </v-flex>
              <v-flex xs2>
                <v-btn
                  small
                  text
                  icon
                  class="px-0 ma-0"
                  :disabled="disabled"
                  @click="remove(index)"
                >
                  <v-icon class="accent--text" style="font-size: 14px">
                    delete
                  </v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </v-slide-y-transition>
  </div>
</template>

<script>
import { listsMixin } from "@/mixins/listsMixin";
import DuctEntryFormCableSelectionTreeselect from "./DuctEntryFormCableSelectionTreeselect";

export default {
  name: "DuctEntryFormCableSelection",

  components: {
    DuctEntryFormCableSelectionTreeselect
  },

  mixins: [listsMixin],

  props: {
    cables: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      typeOptions: null,
      operatorOptions: null,
      cableOptions: []
    };
  },

  computed: {
    disabled() {
      return this.$store.getters.isManholeMasksTabDisabled;
    }
  },

  methods: {
    add() {
      this.cables.push({
        reserved: 0,
        type: null,
        operator: null,
        cable_id: null
      });
    },

    remove(cableIndex) {
      this.cables.splice(cableIndex, 1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Masks/Duct/DuctEntryFormCableSelection.vue